import clsx from "clsx";
import { Assistant } from "./Assistant/Assistant";
import { SectionSettings } from "./SectionSettings/SectionSettings";
import { SidebarStyles } from "./Styles/SidebarStyles";
import { BuilderTourStep } from "@/components/Onboarding/builder";
import { SidebarAtsScan } from "@/components/Sidebar/AtsScan/SidebarAtsScan";
import { SidebarUserJobs } from "@/components/Sidebar/UserJobs/SidebarUserJobs";
import { useAppSelector } from "@/hooks/types";
import { getShowSideBar, getSideBarState } from "@/store/app/selectors";
import { SideBarState } from "@/types/app";

export const Sidebar = () => {
    const sideBarState = useAppSelector(getSideBarState);
    const showSideBar = useAppSelector(getShowSideBar);

    const getTabComponent = () => {
        switch (sideBarState) {
            case SideBarState.STYLES:
                return <SidebarStyles />;
            case SideBarState.ASSISTANT:
                return <Assistant />;
            case SideBarState.EDIT:
                return <SectionSettings />;
            case SideBarState.ATS_SCAN:
                return <SidebarAtsScan />;
            case SideBarState.JOBS:
                return <SidebarUserJobs />;
            default:
                return null;
        }
    };

    return (
        <div
            className={clsx(
                "fixed bottom-0 top-navigationHeight z-20 flex w-side-bar transform flex-col border-r-[1px] border-t-[1px] border-neutral-300 border-r-neutral-300 bg-white py-4 transition-transform duration-300 ease-in-out",
                showSideBar ? "translate-x-0" : "-translate-x-[360px]",
                BuilderTourStep.SIDE_BAR_CONTAINER,
            )}
        >
            {getTabComponent()}
        </div>
    );
};
